import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

const Layout = resolve => require(['pages/layout/index'], resolve)

Vue.use(Router)

export default new Router({
  scrollBehavior(to, from, savePosition) { // 在点击浏览器的“前进/后退”，或者切换导航的时候触发。
    if (savePosition) {
      return savePosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  // mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '登录 - '
      },
      component: () =>
        import ('pages/login/index.vue')
    },
    {
      path: '/bind',
      name: 'bind',
      meta: {
        title: '验证账号 - '
      },
      component: () =>
        import ('pages/login/bind.vue')
    },
    {
      path: '/page',
      name: 'exception',
      component: Layout,
      children: [{
        name: 'error_404',
        path: '404',
        meta: {
          title: '404 - ',
          tagTitle: '404'
        },
        component: () =>
          import ('pages/exception/404.vue')
      }]
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Layout,
      redirect: '/dashboard/index',
      children: [{
        path: 'index',
        name: 'dashboard_index',
        meta: {
          title: '工作台 - ',
          tagTitle: '工作台'
        },
        component: () =>
          import ('pages/dashboard/index.vue')
      }]
    },
    {
      path: '/message',
      name: 'message',
      component: Layout,
      redirect: '/message/index',
      children: [{
        path: 'index',
        name: 'message_index',
        meta: {
          title: '提醒通知 - ',
          tagTitle: '提醒通知'
        },
        component: () =>
          import ('pages/message/index.vue')
      }]
    },
    {
      path: '/approve',
      name: 'approve',
      component: Layout,
      children: [{
        path: 'index',
        redirect: 'index/contract',
        name: 'approve_index',
        component: () =>
          import ('pages/approve/default.vue'),
        children: [{
          path: 'contract',
          meta: {
            title: '合同审批 - ',
            tagTitle: '合同审批'
          },
          component: () =>
            import ('pages/approve/index.vue')
        }, {
          path: 'ad',
          meta: {
            title: '广告审批 - ',
            tagTitle: '广告审批'
          },
          component: () =>
            import ('pages/approve/ad.vue')
        }, {
          path: 'invoce',
          meta: {
            title: '开票审批 - ',
            tagTitle: '开票审批'
          },
          component: () =>
            import ('pages/approve/invoce.vue')
        }, {
          path: 'customer',
          meta: {
            title: '客户申领审批 - ',
            tagTitle: '客户申领审批'
          },
          component: () =>
            import ('pages/approve/customer.vue')
        }]
      }]
    },
    {
      path: '/history',
      name: 'history',
      component: Layout,
      redirect: '/history/approve',
      children: [{
        path: 'approve',
        name: 'history_approve',
        meta: {
          title: '审批历史记录 - ',
          tagTitle: '审批历史记录'
        },
        component: () => import ('pages/history/approve.vue')
      }]
    },
    {
      path: '/log',
      name: 'log',
      component: Layout,
      redirect: '/log/index',
      children: [{
        path: 'index',
        name: 'log_index',
        meta: {
          title: '工作日报 - ',
          tagTitle: '工作日报'
        },
        component: () =>
          import ('pages/log/index.vue')
      },{
        path: 'record',
        name: 'log_record',
        meta: {
          title: '工作记录 - ',
          tagTitle: '工作记录'
        },
        component: () => import('pages/log/record.vue')
      }]
    },
    {
      path: '/customer',
      name: 'customer',
      component: Layout,
      redirect: '/customer/index',
      children: [{
          path: 'index',
          name: 'customer_index',
          meta: {
            title: '客户 - ',
            tagTitle: '客户'
          },
          component: () =>
            import ('pages/customer/index.vue')
        },
        {
          path: 'history',
          name: 'customer_history',
          meta: {
            title: '客户合并历史 - ',
            tagTitle: '客户合并历史'
          },
          component: () =>
            import ('pages/customer/history.vue')
        },
        {
          path: 'detail/:id',
          name: 'customer_detail',
          meta: {
            title: '客户详情 - ',
            tagTitle: '客户详情'
          },
          component: () =>
            import ('pages/customer/detail.vue')
        },
        {
          path: 'public',
          name: 'customer_public',
          meta: {
            title: '公共客户 - ',
            tagTitle: '公共客户'
          },
          component: () =>
            import ('pages/customer/public.vue')
        },
        {
          path: 'apply',
          name: 'customer_apply',
          meta: {
            title: '申领客户记录 - ',
            tagTitle: '申领客户记录'
          },
          component: () =>
            import ('pages/customer/apply.vue')
        }
      ]
    },
    {
      path: '/provider',
      name: 'provider',
      component: Layout,
      redirect: '/provider/index',
      children: [{
          path: 'index',
          name: 'provider_index',
          meta: {
            title: '供应商 - ',
            tagTitle: '供应商'
          },
          component: () =>
            import ('pages/provider/index.vue')
        }
      ]
    },
    {
      path: '/contract',
      name: 'contract',
      component: Layout,
      redirect: '/contract/index',
      children: [{
          path: 'index',
          title: '合同',
          meta: {
            title: '合同 - ',
            tagTitle: '合同'
          },
          component: () =>
            import ('pages/contract/index.vue')
        },
        {
          path: 'create',
          meta: {
            title: '合同申领 - ',
            tagTitle: '合同申领',
          },
          component: () =>
            import ('pages/contract/create.vue')
        },
        {
          path: 'edit/:no',
          meta: {
            title: '合同修改 - ',
            tagTitle: '合同修改'
          },
          component: () =>
            import ('pages/contract/create.vue')
        },
        {
          path: 'detail/:no',
          meta: {
            title: '合同详情 - ',
            tagTitle: '合同详情'
          },
          component: () =>
            import ('pages/contract/detail.vue')
        }
      ]
    },
    {
      path: '/purchase',
      name: 'purchase',
      component: Layout,
      redirect: '/purchase/index',
      children: [{
          path: 'index',
          title: '采购合同',
          meta: {
            title: '采购合同 - ',
            tagTitle: '采购合同'
          },
          component: () =>
            import ('pages/purchase/index.vue')
        }, {
          path: 'save',
          meta: {
            title: '合同申领 - ',
            tagTitle: '合同申领',
          },
          component: () =>
            import ('pages/purchase/create.vue')
        },
        {
          path: 'edit/:no',
          meta: {
            title: '合同修改 - ',
            tagTitle: '合同修改'
          },
          component: () =>
            import ('pages/purchase/create.vue')
        },
        {
          path: 'detail/:no',
          meta: {
            title: '合同详情 - ',
            tagTitle: '合同详情'
          },
          component: () =>
            import ('pages/purchase/detail.vue')
        }
      ]
    },
    {
      path: '/ad',
      name: 'ad',
      component: Layout,
      redirect: '/ad/index',
      children: [{
        path: 'book',
        meta: {
          title: '预定记录 - ',
          tagTitle: '预定记录'
        },
        component: () =>
          import ('pages/ad/book.vue')
      }, {
        path: 'index',
        meta: {
          title: '播放记录 - ',
          tagTitle: '播放记录'
        },
        component: () =>
          import ('pages/ad/ad.vue')
      }, {
        path: 'detail/:id',
        meta: {
          title: '播放记录详情 - ',
          tagTitle: '播放记录详情'
        },
        component: () =>
          import ('pages/ad/ad_detail.vue')
      }, {
        path: 'schedule',
        meta: {
          title: '广告排期表 - ',
          tagTitle: '广告排期表'
        },
        component: () =>
          import ('pages/ad/schedule.vue')
      }, {
        path: 'position',
        meta: {
          title: '广告资源管理 - ',
          tagTitle: '广告资源管理'
        },
        component: () =>
          import ('pages/ad/index.vue')
      }]
    }, {
      path: '/finance',
      name: 'finance',
      component: Layout,
      redirect: '/finance/index',
      children: [{
        path: 'sale',
        meta: {
          title: '销售额 - ',
          tagTitle: '销售额'
        },
        component: () =>
          import ('pages/repay/contract.vue')
      }, {
        path: 'repay',
        meta: {
          title: '回款记录 - ',
          tagTitle: '回款记录'
        },
        component: () =>
          import ('pages/repay/index.vue')
      }, {
        path: 'pay',
        meta: { 
          title: '付款记录 - ',
          tagTitle: '付款记录'
        },
        component: () =>
          import ('pages/pay/index.vue')
      },{
        path: 'repay/detail/:id',
        meta: {
          title: '回款记录详情 - ',
          tagTitle: '回款记录详情'
        },
        component: () =>
          import ('pages/repay/detail.vue')
      }, {
        path: 'invoce',
        meta: {
          title: '开票记录 - ',
          tagTitle: '开票记录'
        },
        component: () =>
          import ('pages/invoce/index.vue')
      }, {
        path: 'invoce/detail/:id',
        meta: {
          title: '开票详情 - ',
          tagTitle: '开票详情'
        },
        component: () =>
          import ('pages/invoce/detail.vue')
      }]
    }, {
      path: '/report',
      name: 'report',
      component: Layout,
      redirect: '/report/work',
      children: [{
        path: 'work',
        meta: {
          title: '工作汇总 - ',
          tagTitle: '工作汇总'
        },
        component: () =>
          import ('pages/report/work.vue')
      }, {
        path: 'sale',
        meta: {
          title: '销售报表 - ',
          tagTitle: '销售报表'
        },
        component: () =>
          import ('pages/report/sale.vue')
      }, {
        path: 'customer',
        meta: {
          title: '客户统计 - ',
          tagTitle: '客户统计'
        },
        component: () =>
          import ('pages/report/customer.vue')
      }, {
        path: 'analysis',
        meta: {
          title: '年度对比分析 - ',
          tagTitle: '年度对比分析'
        },
        component: () =>
          import ('pages/report/analysis.vue')
      }]
    },
    {
      path: '/system',
      name: 'system',
      component: Layout,
      children: [{
          path: 'department',
          meta: {
            tagTitle: '部门管理'
          },
          component: () =>
            import ('pages/system/department.vue')
        },
        {
          path: 'industry',
          meta: {
            title: '行业管理 - ',
            tagTitle: '行业管理'
          },
          component: () =>
            import ('pages/system/industry.vue')
        },
        {
          path: 'tag',
          meta: {
            title: '类别管理 - ',
            tagTitle: '类别管理'
          },
          component: () =>
            import ('pages/system/tag.vue')
        },
        {
          path: 'manager-group',
          meta: {
            title: '职位管理 - ',
            tagTitle: '职位管理'
          },
          component: () =>
            import ('pages/system/manager-group.vue')
        },
        {
          path: 'manager',
          meta: {
            title: '成员管理 - ',
            tagTitle: '成员管理'
          },
          component: () =>
            import ('pages/system/manager.vue')
        },
        {
          path: 'account',
          meta: {
            title: '个人设置 - ',
            tagTitle: '个人设置'
          },
          component: () =>
            import ('pages/system/account.vue')
        },
        {
          path: 'approval',
          meta: {
            title: '审批流程设置 - ',
            tagTitle: '审批流程设置'
          },
          component: () => import('pages/system/approval.vue')
        },
        {
          path: 'score',
          meta: {
            title: '绩效考核设置 - ',
            tagTitle: '绩效考核设置'
          },
          component: () => import('pages/system/score.vue')
        },
        {
          path: 'appmanager',
          meta: {
            title: '业务参数设置 - ',
            tagTitle: '业务参数设置'
          },
          component: () => import('pages/system/appmanager.vue')
        }
      ]
    },
    {
      path: '/sale-plan',
      name: 'sale-plan',
      component: Layout,
      redirect: '/sale-plan/index',
      children: [{
        path: 'index',
        meta: {
          title: '销售计划 - ',
          tagTitle: '销售计划'
        },
        component: () =>
          import ('pages/sale-plan/index.vue')
      }]
    },
    //公告
    {
      path: '/notice',
      redirect: '/notice/index',
      component: Layout,
      children: [{
          path: 'index',
          meta: {
            title: '公告 - ',
            tagTitle: '公告'
          },
          component: () =>
            import ('pages/notice/index.vue')
        },
        {
          path: 'detail/:id',
          meta: {
            title: '公告详情 - ',
            tagTitle: '公告详情'
          },
          component: () =>
            import ('pages/notice/detail.vue')
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js